import { render } from "./ApplicationCal.vue?vue&type=template&id=22c32538&scoped=true"
import script from "./ApplicationCal.vue?vue&type=script&lang=js"
export * from "./ApplicationCal.vue?vue&type=script&lang=js"

import "./ApplicationCal.vue?vue&type=style&index=0&id=22c32538&scoped=true&lang=css"

import exportComponent from "C:\\Users\\lenovo\\Desktop\\canadianlic\\client\\app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22c32538"]])

export default __exports__